// components/gtm.tsx
import Script from 'next/script';
import React from 'react';

/**
 * Google Tag Manager 用のスクリプトを挿入するテンプレート。
 * @returns GTM スクリプト群
 */
export const GoogleTagManager = () => {
  return (
    <>
      <Script
        strategy='afterInteractive'
        src='https://www.googletagmanager.com/gtag/js?id=G-YFWS6Z7NL8'
      />
      <Script
        id='gtm'
        strategy='afterInteractive'
        // 初期表示後に dataLayer を立ち上げ、全ページ共通で計測を有効にする。
        dangerouslySetInnerHTML={{
          __html: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-YFWS6Z7NL8');
        `,
        }}
      />
    </>
  );
};

export default GoogleTagManager;
